import { render, staticRenderFns } from "./InvoiceLocking.vue?vue&type=template&id=64078a24"
import script from "./InvoiceLocking.vue?vue&type=script&lang=js"
export * from "./InvoiceLocking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports